import gql from 'graphql-tag';

export const queryForContacts = gql`
  query queryForContacts(
    $limit: Int
    $page: Int
    $query: ContactSortOrQuery
    $sort: ContactSortOrQuery
  ) {
    queryForContacts(limit: $limit, page: $page, query: $query, sort: $sort) {
      items {
        id
        firstName
        lastName
        nickName
        inactiveAdAccount
        afterHoursPhoneNumber
        speedDial
        version
        Company {
          id
          name
          abbreviation
          version
        }
        adAccountName
        JobRole {
          id
          name
          version
        }
        ReportsTo {
          id
          firstName
          lastName
          ReportsTo {
            id
            firstName
            lastName
            ReportsTo {
              id
              firstName
              lastName
            }
          }
          version
        }
        businessMobile
        businessPhone
        home
        other
        personalMobile
        adAccountName
        city
        Availabilities {
          id
          ContactId
          start
          end
          version
        }
      }
      totalRecords
    }
  }
`;
